module.exports = __webpack_public_path__ + "img/recicladores.299073ea.png";